import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function SafetySection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-6 md:mb-8">
          <i className="ri-shield-star-line text-accent-600 text-2xl md:text-3xl"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4 md:mb-6">
          {t("safety.title")}
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed mb-8 md:mb-10">
          {t("safety.description")}
        </p>
        <Link
          to="/artykul/poradnik-bezpieczenstwa-kakobuy"
          className="inline-flex items-center gap-2 px-7 py-3.5 text-sm md:text-base font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
        >
          <i className="ri-arrow-right-line"></i>
          {t("safety.cta")}
        </Link>
      </div>
    </section>
  );
}